import request from '@/config/axios'

export const getBizOppPage = (params: any) =>
  request.get({ url: '/bosscircle/biz-opp/page', params })

/** 供需详情：含图片、位置、分类与互动数；联系方式由后端恒为掩码下发 */
export const getBizOpp = (id: number | string) =>
  request.get({ url: '/bosscircle/biz-opp/get', params: { id } })

export const updateBizOppStatus = (id: number, status: number) =>
  request.put({ url: '/bosscircle/biz-opp/status', params: { id, status } })

export const deleteBizOpp = (id: number) =>
  request.delete({ url: '/bosscircle/biz-opp/delete', params: { id } })
